import { ref } from 'vue'
import { throttle } from 'lodash'

let observer
let top
let headerHeight
const currentHeaderHeight = ref()

export { currentHeaderHeight }

const stickyScroll = throttle(function (header) {
  const currentTop = window.scrollY
  const diff = headerHeight * -1
  currentHeaderHeight.value = headerHeight

  if (top < currentTop) {
    if (currentTop > headerHeight) {
      header.style.cssText = `transform: translateY(${diff}px)`
      header.style.setProperty('--stickyFiltersDiff', diff + headerHeight)
      currentHeaderHeight.value = 0
    }
  } else if (top > currentTop) {
    header.style.cssText = null
    header.style.setProperty('--stickyFiltersDiff', diff + 1)
    currentHeaderHeight.value = headerHeight
  }

  top = currentTop
}, 50)

export default {
  install(Vue) {
    Vue.directive('sticky-header', {
      mounted: function (el) {
        observer = new ResizeObserver(entries => {
          entries.forEach(entry => {
            document.body.style.setProperty('padding-top', entry.contentRect.height + 'px')
            currentHeaderHeight.value = headerHeight = entry.contentRect.height
          })
        })

        observer.observe(el)

        top = window.scrollY
        el._scrollCallback = () => stickyScroll(el)
        window.addEventListener('scroll', el._scrollCallback)
      },
      unmounted: function (el) {
        observer.unobserve(el)
        observer.disconnect()
        window.removeEventListener('scroll', el._scrollCallback)
      }
    })
  }
}
